import {
  getUniqueVals
} from "./_evaluate";

import * as Util from "./_utilites"
import * as d3 from "d3"

/**
 * Map values with color range
 * @function
 * @param {String[]} elements_Ids - element unique ids
 * @param {String[]|Number[]} values - values of each element
 * @param {String[]} colorRange - array of strings colors 
 * @return {String[]}  - colors
 */
export function colorBy(elements_Ids, values, colorRange, customDomain=null) {

  // Check if the lengths of 'elements_Ids' and 'values' are equal
  if (elements_Ids.length !== values.length) return null; // handle the error warning

  // Define default color
  const defaultColor = 'rgb(128, 128, 128)'; // Replace with your desired default color
  
  // Create visualization settings for the given 'values'
  let visSetting = settings(values);

  // This will hold IDs that don't have valid values
  var ids_inValidValue = [];

  // Create a dictionary where each key-value pair corresponds to an element ID and its corresponding value
  var elementDict = values.reduce(function (elementDict, val, index) {
    // Convert 'val' to a number if possible
    var numValResult = Util.getNumValIfPossible(val);
    // Check if the current value exists in 'uniqueVals'
    let idx = visSetting.uniqueVals.indexOf(numValResult.val);
    if(idx !== -1 ) elementDict[elements_Ids[index]] = numValResult.val;
    else ids_inValidValue.push(elements_Ids[index]);
    return elementDict;
  }, {})

  // Color mapping
   // Create a linear scale for mapping values to colors
  var scale = d3.scaleLinear();
  scale.range(colorRange);

  // Determine the domain for the scale
  var domain = customDomain === null ? d3.extent(visSetting.uniqueVals) : customDomain;
  //var extent = d3.extent(visSetting.uniqueVals);
  
  // Set the domain for the scale
  scale.domain(domain);
  // Adjust the scale's domain based on the range of unique values
  if (customDomain === null) {
    setScaleFromExtents(visSetting.range);
  } else {
    setScaleFromExtents(customDomain);
  }
  function setScaleFromExtents(extents) {
    var interimScale = d3
      .scaleLinear()
      .domain([0, colorRange.length - 1])
      .range(extents);

    var newDomain = colorRange.map(function (c, i) {
      return interimScale(i);
    });
    scale.domain(newDomain);
  }

  var mappedColors = [];
  // Map each value in 'elementDict' to a color
  Object.values(elementDict).map(function (val) {
    if(visSetting.linear){
      if(customDomain !== null && (val < customDomain[0] || val > customDomain[1])) {
        // If a custom domain is defined and the value falls outside of it, assign the default color
        mappedColors.push(defaultColor);
      } else {
        // Otherwise, assign the color that corresponds to the value according to the scale
        mappedColors.push(scale(val));
      }
    } else {
      mappedColors.push(scale(visSetting.uniqueVals.indexOf(val)));
    }
  });

  let legendDict = {};
  
  for (let index = 0; index < visSetting.uniqueVals.length; index++) {
    let val = visSetting.uniqueVals[index];
    if(visSetting.linear)  legendDict[val]= scale(val);
    else legendDict[val]= scale(index);
  }

  return {
    ids: Object.keys(elementDict),
    colors: mappedColors,
    values: Object.values(elementDict),
    ids_inValidValue: ids_inValidValue,
    uniqueVals: visSetting.uniqueVals,
    range: visSetting.range,
    linear: visSetting.linear, 
    legendDict: legendDict
  }


}


export function settings(values) {
  var NaNs = [];
  var returnObj = {};

  var uniqueVals = values.filter((v, i, a) => a.indexOf(v) === i).sort(Util.naturalSort);

  let filtered = uniqueVals.map(function (v) {
    var numValResult = Util.getNumValIfPossible(v);
    if (numValResult.isNaN) NaNs.push(numValResult.val);
    return numValResult.val;
  }).filter(function (val) {
    return !Util.valueIsInvalid(val);
  })

  returnObj.uniqueVals = filtered;
  returnObj.linear = Boolean(!NaNs.length);
  returnObj.NaNs = NaNs;
  returnObj.range = (NaNs.length) ? [0, returnObj.uniqueVals.length - 1] : [d3.min(returnObj.uniqueVals), d3.max(returnObj.uniqueVals)];
  return returnObj;

}